import { FC } from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import { MemberSetCreate } from "./MemberSetCreate";
import MemberSetCreateFiltered from "./MemberSetCreateFiltered";
import MemberSetDetail from "./MemberSetDetail";
import { MemberSets } from "./MemberSets";

const MemberSetsRouter: FC<RouteComponentProps<unknown, unknown, { sourceMemberSetId: number }>> = (props) => {
  return (
    <Switch location={props.location}>
      <Route
        exact={true}
        path={props.match.url}
        render={() => <MemberSets />}
      />

      <Route
        exact={true}
        path={`${props.match.url}/create`}
        render={() => <MemberSetCreate />}
      />

      <Route
        exact={true}
        path={`${props.match.url}/create-filtered`}
        component={MemberSetCreateFiltered}
      />

      <Route
        exact={true}
        path={`${props.match.url}/:memberSetId/detail`}
        component={MemberSetDetail}
      />
    </Switch>
  );
};

export default MemberSetsRouter;
